export default "__VITE_ASSET__z3GV2mZP__"